import React, { useState } from 'react';
import { Button, CircularProgress, Box, Snackbar, Alert } from '@mui/material';

import ActionConfirmationDialog from './ActionConfirmationDialog'; // Adjust the import path as necessary

const ActionButtons = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [actionType, setActionType] = useState('');
  const [comments, setComments] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const handleActionClick = action => {
    setActionType(action);
    setDialogOpen(true);
  };

  const handleClose = () => {
    setDialogOpen(false);
    setComments('');
  };

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      // Dummy API call - replace with actual API endpoint
      const accessToken = localStorage.getItem('access_token');
      const refreshToken = localStorage.getItem('refresh_token');

      await new Promise(resolve => setTimeout(resolve, 1500)); // Simulated delay

      const response = await fetch('https://your-api-endpoint/action', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Access-Token': accessToken,
          'X-Refresh-Token': refreshToken
        },
        body: JSON.stringify({
          action: actionType,
          comments: comments,
          timestamp: new Date().toISOString()
        })
      });
      if (!response.ok) {
        throw new Error('API call failed');
      }
      setSnackbarMessage(
        `Successfully ${
          actionType === 'Referral' ? 'Referred' : actionType + 'd'
        }`
      );
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      handleClose();
    } catch (error) {
      setSnackbarMessage('Could not complete action, try again later');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      handleClose();
      console.error('Error:', error);
    } finally {
      setIsLoading(false);
      setDialogOpen(false);
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbarOpen(false);
  };

  return (
    <>
      {isLoading && (
        <Box className='fixed top-0 left-0 w-screen h-screen bg-black/40 z-[9999] flex items-center justify-center'>
          <CircularProgress sx={{ color: '#ea580c' }} size={60} />
        </Box>
      )}

      <div className='flex justify-center mt-12 space-x-4 '>
        <Button
          variant='contained'
          className='!bg-[#22c55e] hover:!bg-[#16a34a]'
          onClick={() => handleActionClick('Approve')}
        >
          Approve
        </Button>
        <Button
          variant='contained'
          className='!bg-[#ea580c] hover:!bg-[#c2410c]'
          onClick={() => handleActionClick('Decline')}
        >
          Decline
        </Button>
        <Button
          variant='contained'
          className='!bg-[#000000] hover:!bg-[#262626]'
          onClick={() => handleActionClick('Referral')}
        >
          Referral
        </Button>
      </div>

      <ActionConfirmationDialog
        dialogOpen={dialogOpen}
        handleClose={handleClose}
        handleConfirm={handleConfirm}
        actionType={actionType}
        comments={comments}
        setComments={setComments}
      ></ActionConfirmationDialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ActionButtons;
